import React, { ReactElement } from 'react'
import { Rect, Text } from 'react-konva'

interface RackPositionProps {
    x: number
    y: number
    width: number
    height: number
    mainText: string
    subText?: string
    textColor?: string | undefined
    boxColor: string | undefined
}

export const RackPosition = (props: RackPositionProps, config: any): ReactElement => {
    const { x, y, width, height, boxColor, mainText, subText, textColor } = props
    const text = subText ? `${mainText} \n ${subText}` : mainText
    return (
        <>
            <Rect x={x} y={y} width={width} height={height} fill={boxColor || 'grey'} {...config} />
            <Text
                x={x}
                y={y}
                width={width}
                fontStyle="bold"
                fontSize={10}
                height={height}
                padding={5}
                fill={textColor}
                text={text}
                verticalAlign="middle"
                align="center"
            />
        </>
    )
}
